"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportRiskTargetsDialog = void 0;
var React = require("react");
var dialog_1 = require("../dialog");
var typestyle_1 = require("typestyle");
var generic_1 = require("../generic");
var multiSelect_1 = require("../lib/multiSelect");
var importRiskTargetsContext_1 = require("../../context/admin/importRiskTargetsContext");
var buttons_1 = require("../buttons");
var ImportRiskTargetsDialog = function (props) {
    return (React.createElement(importRiskTargetsContext_1.default.Consumer, null, function (context) {
        return React.createElement(dialog_1.Dialog, { isOpen: context.isOpen, isReady: context.isReady, contentLabel: gettext("Import Risk Targets"), shouldCloseOnOverlayClick: true, onClose: context.closeDialog, forcedWidth: "550px" },
            React.createElement("div", { className: (0, typestyle_1.classes)("Dialog__ScrollWrapper", "ImportRiskTargetsDialog") },
                React.createElement("label", { className: "gm--fullwidth" },
                    gettext("Project"),
                    ":",
                    React.createElement(generic_1.ChoiceSelect, { choices: context.project_choices, value: context.selected_project, onChange: function (e) {
                            return context.onProjectSelect(e.currentTarget.value);
                        } })),
                context.selected_project &&
                    React.createElement("label", { className: "gm--fullwidth" },
                        gettext("Risk Targets"),
                        React.createElement(multiSelect_1.Multiselect, { choices: context.target_choices, value: context.selected_targets, name: "risk_targets", onChange: function (checked) {
                                context.onRiskTargetsSelect(checked);
                            }, classes: "gm--fullwidth" }))),
            React.createElement(generic_1.FloatRight, null,
                React.createElement(buttons_1.PrimaryButton, { onClick: function () { return context.onSave().then(props.onSaveSuccess); } }, gettext("Save"))));
    }));
};
exports.ImportRiskTargetsDialog = ImportRiskTargetsDialog;
